import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getAllBannerByTypeAsync,
  getAllBanner2ByTypeAsync,
  getcountBookmarkAsync,
  getAllOnlyForYouAsync,
  userWallOfFameAsync,
} from "../async.api";

const initialState = {
  bannerLoader: false,
  banner2Loader: false,
  banners: [],
  banners2: [],
  AllOnlyForYouLoader: false,
  AllOnlyForYou: [],
  countBookmarkbyidLoader: false,
  countBookmarkbyid: [],
  walloffameLoader: false,
  walloffame: [],
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(userWallOfFameAsync.pending), (state) => {
      state.walloffameLoader = true;
      state.walloffame = [];
    });
    builder.addMatcher(
      isAnyOf(userWallOfFameAsync.fulfilled),
      (state, action) => {
        state.walloffameLoader = false;
        state.walloffame = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(userWallOfFameAsync.rejected),
      (state, action) => {
        state.walloffameLoader = false;
        state.walloffame = [];
      }
    );

    builder.addMatcher(isAnyOf(getAllBannerByTypeAsync.pending), (state) => {
      state.bannerLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getAllBannerByTypeAsync.fulfilled),
      (state, action) => {
        state.bannerLoader = false;
        state.banners = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllBannerByTypeAsync.rejected),
      (state, action) => {
        state.bannerLoader = false;
        state.banners = action.payload.data;
      }
    );

    builder.addMatcher(isAnyOf(getAllBanner2ByTypeAsync.pending), (state) => {
      state.banner2Loader = true;
    });
    builder.addMatcher(
      isAnyOf(getAllBanner2ByTypeAsync.fulfilled),
      (state, action) => {
        state.banner2Loader = false;
        state.banners2 = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllBanner2ByTypeAsync.rejected),
      (state, action) => {
        state.banner2Loader = false;
        state.banners2 = action.payload.data;
      }
    );

    builder.addMatcher(isAnyOf(getcountBookmarkAsync.pending), (state) => {
      state.countBookmarkbyidLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getcountBookmarkAsync.fulfilled),
      (state, action) => {
        state.countBookmarkbyidLoader = false;
        state.countBookmarkbyid = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(getcountBookmarkAsync.rejected),
      (state, action) => {
        state.countBookmarkbyidLoader = false;
        state.countBookmarkbyid = action.payload;
      }
    );
    builder.addMatcher(isAnyOf(getAllOnlyForYouAsync.pending), (state) => {
      state.AllOnlyForYouLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getAllOnlyForYouAsync.fulfilled),
      (state, action) => {
        state.AllOnlyForYouLoader = false;
        state.AllOnlyForYou = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllOnlyForYouAsync.rejected),
      (state, action) => {
        state.AllOnlyForYouLoader = false;
      }
    );
  },
});

export default dashboardSlice.reducer;
